/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportForDeviceCounterResponseElements,
    ReportForDeviceCounterResponseElementsFromJSON,
    ReportForDeviceCounterResponseElementsFromJSONTyped,
    ReportForDeviceCounterResponseElementsToJSON,
} from './ReportForDeviceCounterResponseElements';

/**
 * 
 * @export
 * @interface ReportForDeviceCounterResponse
 */
export interface ReportForDeviceCounterResponse {
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceCounterResponse
     */
    hardwareId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceCounterResponse
     */
    usageId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceCounterResponse
     */
    deviceTypeId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceCounterResponse
     */
    deviceTypeName: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForDeviceCounterResponse
     */
    count: number | null;
    /**
     * 
     * @type {Date}
     * @memberof ReportForDeviceCounterResponse
     */
    minDate: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ReportForDeviceCounterResponse
     */
    maxDate: Date | null;
    /**
     * 
     * @type {Array<ReportForDeviceCounterResponseElements>}
     * @memberof ReportForDeviceCounterResponse
     */
    elements: Array<ReportForDeviceCounterResponseElements> | null;
}

export function ReportForDeviceCounterResponseFromJSON(json: any): ReportForDeviceCounterResponse {
    return ReportForDeviceCounterResponseFromJSONTyped(json, false);
}

export function ReportForDeviceCounterResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForDeviceCounterResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hardwareId': json['hardwareId'],
        'usageId': json['usageId'],
        'deviceTypeId': json['deviceTypeId'],
        'deviceTypeName': json['deviceTypeName'],
        'count': json['count'],
        'minDate': (json['minDate'] === null ? null : new Date(json['minDate'])),
        'maxDate': (json['maxDate'] === null ? null : new Date(json['maxDate'])),
        'elements': (json['elements'] === null ? null : (json['elements'] as Array<any>).map(ReportForDeviceCounterResponseElementsFromJSON)),
    };
}

export function ReportForDeviceCounterResponseToJSON(value?: ReportForDeviceCounterResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hardwareId': value.hardwareId,
        'usageId': value.usageId,
        'deviceTypeId': value.deviceTypeId,
        'deviceTypeName': value.deviceTypeName,
        'count': value.count,
        'minDate': (value.minDate === null ? null : value.minDate.toISOString()),
        'maxDate': (value.maxDate === null ? null : value.maxDate.toISOString()),
        'elements': (value.elements === null ? null : (value.elements as Array<any>).map(ReportForDeviceCounterResponseElementsToJSON)),
    };
}

